"use strict";
/*
 * Created on 05 24 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailRowReleaseDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactReportDetailRowReleaseDTO, _DomainObject_1$Domai);

  /**
   * @param releaseId ID of the release.
   * @param releaseName Name of the release.
   * @param workflowType Workflow type of the release.
   * @param selloutReleaseType Sellout type of the release.
   * @param values Impact values.
   */
  function SelloutImpactReportDetailRowReleaseDTO(releaseId, releaseName, workflowType, selloutReleaseType, values) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailRowReleaseDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRowReleaseDTO).call(this));
    _this.releaseId = releaseId;
    _this.releaseName = releaseName;
    _this.workflowType = workflowType;
    _this.selloutReleaseType = selloutReleaseType;
    _this.values = values;
    return _this;
  }

  return SelloutImpactReportDetailRowReleaseDTO;
}(DomainObject_1.DomainObject);

exports.SelloutImpactReportDetailRowReleaseDTO = SelloutImpactReportDetailRowReleaseDTO;